omadapp.singletons.generadorAnimaticas = new(function() {
    var t = this;
    var $ = jQuery
    t.generar = generar


    var ids = 0


    function eliminar() {

    }

    function generar(animatica, conf, callback) {
        //trace("generadorAnimaticas::generar")
        //trace(conf)
        //trace(animatica)

        ids++
        return new Animatica(ids, animatica, conf, callback)
    }

    function Animatica(id, animatica, conf, callback) {
        var t = this
        t.id = id
        t.pausar = pausar
        t.reanudar = reanudar
        t.parar = parar
        t.stop = parar
        t.finAnimatica = finAnimatica
        t.getAnimatica = getAnimatica
        t.ejecutar = ejecutar
        var $b = $("body")
        var tokensUtilizados =""
        omadapp.singletons.implementador.implementar(t,omadapp.interfaces.pausable)
        animatica = clonar(animatica)
        //trace ("animatica ---")
        //trace (animatica)
        var intervalo, hechos
        var fps = 1000 / conf.fps
        parar()
        var anim = animatica.keyframes
        var frame = 0
        var primero = true
        var modificadorFrame = 0
        var esperarFrame = 0
        var esperadores = []
        hechos = []
        conf.actores.animatica = t
        var dinicial = new Date()
        trace ("tokens utilizados: "+tokensUtilizados)
        var lastFrame = 0
        var pausado = false
        var eventos = []
        ejecutar()

        function kill() {
            //trace ("***************")
            //trace ("commons -> Animatica::kill "+id)
            //trace ("***************")
            animatica = null

            while(eventos.length>0) {
                $b.off(eventos.pop(),reanudarAnimacion)
            }
        }
        function ejecutar() {
            frame = 0
            lastFrame = 0
            hechos = []
            dinicial = new Date()
           // t.reanudar()
            ejecutarIntervalo()

        }
        function ejecutarIntervalo () {
            trace ("Animatica::ejecutarIntervalo "+primero)
            parar()
            pausado = false
            t.selfPausado =false

            for (var i = 0;i<esperadores.length;i++) {
                var e = esperadores[i]
                if (e.activo) {
                    primero = false
                    modificadorFrame = Math.max((frame-e.frame.frame),0)
                    frame==e.frame.frame
                    parar()
                    return
                }
            }

            intervalo = setInterval(function() {
                frame = Math.ceil((new Date() - dinicial) / fps)
                if (primero) {
                    modificadorFrame = Math.max((frame-esperarFrame)-1,0)
                    primero = false
                }
                animar(frame-modificadorFrame)
            }, fps)
        }

        function finAnimatica(silencioso) {
            silencioso = silencioso!=null?silencioso : false
            parar()
            //console.trace ("commons -> Animatica::finAnimatica")
            //trace (conf.loop)
            $("body").trigger("generadorAnimaticas.fin")
            while (esperadores.length>0) {
                esperadores.pop().kill()
            }
            if (callback&&!silencioso) {
                callback(t)
            }
            if (conf.loop) {
                ejecutar()
            } else {
                kill()
            }
            for (var n in conf.actores) {
                var ac = conf.actores[n]
                //trace (ac)
                if (ac!=t&&ac.isAnimable) {
                    ac.cancelarAnimacion()
                } 
            }         
        }

        function animar(frm) {

           // trace ("Frame: "+frm)
            window.frameAnimado= (id+": "+frm)
            if (animatica==null) parar()
          //  if (pausado)  return
                //trace ("commons --> animar")
            for (var i = anim.length - 1; i >= 0; i--) {
                var f = anim[i]
                if (f.frame <= frm && hechos.indexOf(f.frame) < 0) {

                    var puedeGuardar = true
                    if (f.fin_en_ultima) {
                        var contI = conf.actores.escena.contIteracion+1
                        var maxI = conf.actores.escena.game.persistence.baraja.length
                        //trace ("es final? "+contI+"  "+maxI)
                        if (contI>=maxI) {
                            puedeGuardar = false
                            finAnimatica()
                            return
                        }
                    }
                    ejecutarAcciones(f.acciones)
                    function ejecutarAcciones (acciones) {
                        //trace ("ejecutarAcciones de frame")
                        for (var n in acciones) {
                            //trace("commons -> dentro")
                            if (conf.actores[n]) {
                                var accion = acciones[n]
                                //trace("commons -> ++++  "+accion[0])
                                if (accion[0]=="finAnimatica") {
                                    //trace ("es fin de animatica, no puede guardar")
                                    puedeGuardar = false
                                }
                                conf.actores[n][accion[0]](accion[1])
                            } else if (n.indexOf("function")==0) {
                                acciones[n]()
                            } else if (n.indexOf("condition")==0) {
                                var accion = acciones[n]
                                for (var i = 0; i < accion.condiciones.length; i++) {
                                    if (accion.ejecutarCorrectas===true) {
                                        if (accion.condiciones[i][0]===true) {
                                            ejecutarAcciones(accion.condiciones[i][1])
                                        }
                                    } else {
                                        if (accion.condiciones[i][0]!==true) {
                                            ejecutarAcciones(accion.condiciones[i][1])
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (puedeGuardar) {
                        //trace ("anitest -> *** guardando "+f.frame+"  "+frm)
                        //trace (f)
                        hechos.push(f.frame)
                    }

                    if (f.esperar&&conf.actores[f.esperar].completeEvent) {
                       // trace ("anitest -> esperando en frame: "+frm)
                       
                        var act = conf.actores[f.esperar]
                        esperadores.push(new Esperador(animatica,f,conf.actores[f.esperar],$b,function() {
                            reanudarAnimacion()
                        }))

                        parar()
                    }
                }
            }
                    lastFrame = frm
        }
        function Esperador (animatica,frame,instanciaActor,$b,callback) {
            var t= this;
            t.kill = kill
            t.frame = frame
            var actor  = frame.esperar
            //trace ("actor: "+actor)
            //trace (frame.acciones[actor])
            var accion = frame.acciones[actor][0]
            t.activo = true
            $b.on(instanciaActor.completeEvent,realizarCallback)

            function realizarCallback(e,f,g) {
                //trace ("callback---")
                //trace (animatica)
                //trace (f)
                //trace (frame)
                //trace (g+"   "+accion)
                //trace (instanciaActor.idInstancia+"  <-> "+f.idInstancia)
                if (instanciaActor.idInstancia!=f.idInstancia) return;
                if (g!=accion) return;
                t.activo = false
               $b.off(instanciaActor.completeEvent,realizarCallback)
               //trace ("realizarCallback ---")
               //trace (actor)
               //trace (accion)
               
               callback(t)

            }

            function kill () {
                t.frame = null
                $b.off(instanciaActor.completeEvent,realizarCallback)
                instanciaActor = null
            }
        }

        function reanudarAnimacion (a,target) {
            //trace ("commons -> Animatica::reanudarAnimacion")
            //trace (target.completeEvent)
           
            dinicial = new Date(new Date().getTime()-Math.round((lastFrame-1)*fps))
            esperarFrame =  lastFrame
            trace ("esperarFrame "+esperarFrame)
            primero = true
            ejecutarIntervalo()
        }

        function reanudar() {

            if (!t.selfPausado) return
            t.super.reanudar.call(t)
            //trace ("commons -> Animatica::reanudar")
            // esto falta. Habrá que ver como detectar los audios en marcha
            //trace ("commons -> reanudar-------")
            //trace (dinicial)
            //trace ("commons -> lastFrame: "+lastFrame)
            var elapsado = Math.round((lastFrame-1)*fps)
            //trace (elapsado)
            dinicial = new Date(new Date().getTime()-elapsado)
            //trace (dinicial)
            //trace (hechos)
            for (var n in conf.actores) {
                if (conf.actores[n]!=t&& conf.actores[n].reanudar) {
                    conf.actores[n].reanudar()
                } 
            }
            ejecutarIntervalo()
        }
        function pausar () {
            if (t.selfPausado) return
            t.super.pausar.call(t)
            parar()
            //trace ("generadorAnimaticas::pausar")
            //trace (conf.actores)
            for (var n in conf.actores) {
                if (conf.actores[n]!=t&& conf.actores[n].pausar) {
                    conf.actores[n].pausar()
                } 
            }
        }
        function parar(pararLoop) {

            //trace ("commons -> Animatica::parar")
            //trace ("commons -> lastFrame: "+lastFrame)
            pausado= true
            clearInterval(intervalo)
            
            if (pararLoop) {
                conf.loop = false
                kill()
            }

        }

        function clonar(obj) {
            if (typeof obj === "string") {
                return procesarToken(obj)
            }

            if (Array.isArray(obj)) {
                var res = [];

                for (var i = 0; i < obj.length; i++) {
                    res.push(clonar(obj[i]))
                }
                return res
            }

            if (typeof obj === 'object') {
                var res = {}
                for (var n in obj) {
                    res[n] = clonar(obj[n])
                }
                return res
            }

            return obj
        }
        function addTokenToList (str){
            if (tokensUtilizados.indexOf(str)<0) {
                tokensUtilizados+=str+", "
            }
        }
        function procesarToken(str, id) {
            /*trace ("procesarToken")
            trace (str)
            trace (id)
            trace (conf.params)*/
            for (var n in conf.params) {
                if (str.indexOf(n)>-1) addTokenToList (n)

                if (str == n) {
                    str = conf.params[n]
                    return str
                } else {

                    str = str.replace(n, conf.params[n])
                }
            }

            return str
        }

        function getAnimatica () {
            return animatica
        }
    }
})